<template>
  <a-card
    class="upload_card"
    hoverable
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div class="main_body" v-if="hasSheet">
      <div v-if="isHover" class="upload_body">
        <a-upload
          class="upload_icon"
          accept=".evxml,.musicxml"
          :before-upload="handleBeforeUpload"
        >
          <div class="icon">
            <UploadOutlined :style="{ color: store.state.themeColor }" />
          </div>
          <p class="text">上传evxml/musicxml文件</p>
        </a-upload>
      </div>
      <div v-else>
        <a-descriptions title="曲谱文件" bordered :column="3">
          <a-descriptions-item label="曲谱文件地址" :span="3">
            {{ formData.evxml_file_url || "请上传evxml/musicxml文件" }}
          </a-descriptions-item>
          <a-descriptions-item label="曲谱文件MD5" :span="3">
            {{ formData.evxml_file_md5 || "请上传evxml/musicxml文件" }}
          </a-descriptions-item>
          <a-descriptions-item label="曲谱文件大小" :span="3">
            {{ formData.evxml_file_size || "请上传evxml/musicxml文件" }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div v-else>
      <a-descriptions title="曲谱文件" bordered :column="3">
        <a-descriptions-item label="曲谱文件地址" :span="3">
          <a-tooltip>
            <template #title>{{ formData.evxml_file_url }}</template>
            {{
              formData.evxml_file_url.length > 40
                ? formData.evxml_file_url.substr(0, 40) + "..."
                : formData.evxml_file_url
            }}
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item label="曲谱文件MD5" :span="3">
          {{ formData.evxml_file_md5 }}
        </a-descriptions-item>
        <a-descriptions-item label="曲谱文件大小" :span="3">
          <a-space class="sheet-space" :size="50">
            <span>{{ formData.evxml_file_size }}</span>
            <div class="sheet-space-work">
              <a-upload
                :showUploadList="false"
                accept=".evxml,.musicxml"
                :before-upload="handleBeforeUpload"
              >
                <UploadOutlined :style="{ color: store.state.themeColor }" />
                <a>重新选择</a>
              </a-upload>
              <a @click="showDeleteModal"><DeleteOutlined />清空</a>
              <a v-if="handleShowEditSheetButton()" @click="jumpToEdit"><EditOutlined />曲谱编辑</a>
            </div>
          </a-space>
          <a-modal
            v-if="deleteVisible"
            title="警告"
            :visible="deleteVisible"
            :maskClosable="false"
            okText="确定"
            cancelText="取消"
            @ok="handleDeleteSheet"
            @cancel="handleDeleteCancel"
          >
            是否确认删除当前的evxml曲谱文件？
          </a-modal>
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </a-card>
</template>

<script>
import { computed, ref, toRaw } from '@vue/reactivity'
import { onMounted } from 'vue'
import { UploadOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { uploadFileToOss } from '@/utils/oss'
import { message } from 'ant-design-vue'
import config from '@/config'
export default {
  emits: ['onChange'],
  components: {
    UploadOutlined,
    DeleteOutlined,
    EditOutlined
  },
  props: {
    form: {
      type: Object,
      default: () => { return {} }
    }
  },
  setup (props, { emit }) {
    const formData = computed(() => props.form)
    const store = useStore()
    const isHover = ref(false)
    const handleMouseEnter = () => {
      isHover.value = true
    }
    const hasSheet = computed(() => formData.value.evxml_file_url === undefined || formData.value.evxml_file_url === '')

    const deleteVisible = ref(false)

    const handleMouseLeave = () => {
      isHover.value = false
    }

    const showDeleteModal = () => {
      deleteVisible.value = true
    }

    const handleDeleteCancel = () => {
      deleteVisible.value = false
    }

    const handleDeleteSheet = () => {
      const formInfo = {
        ...toRaw(formData.value),
        evxml_file_url: '',
        evxml_file_size: undefined,
        evxml_file_md5: ''
      }
      console.log(formInfo)
      emit('onChange', formInfo)
      handleDeleteCancel()
    }

    const uploadDataForm = (url, md5, size) => {
      console.log(url, md5, size)
      const formInfo = {
        ...toRaw(formData.value),
        evxml_file_url: url,
        evxml_file_size: size,
        evxml_file_md5: md5
      }
      console.log(formInfo)
      emit('onChange', formInfo)
    }

    const handleBeforeUpload = file => {
      console.log('上传曲谱', file)
      try {
        uploadFileToOss(file, true, undefined, '', false).then(data => {
          const { url, md5, size } = data
          uploadDataForm(url, md5, size)
          message.success('上传曲谱成功')
        })
      } catch (error) {
        console.log(error)
      }
      return false
    }

    const jumpToEdit = () => {
      const url = window.location.href
      const index = url.search('/resource/sheet-songs/')
      const id = url.slice(index, url.length).split('/')[3]
      const token = localStorage.getItem('resource_token')
      const { acc_file_url, ori_file_url } = formData.value
      const resourceCenter = config.mainApps.institutionPlatform.baseURL
      const resourceCenterApiPrefix = config.mainApps.institutionPlatform.apiPrefix
      const shenyue = config.mainApps.shenyue.baseURL
      const shenyueApiPrefix = config.mainApps.shenyue.apiPrefix
      window.open(`${config.musicScore}/skip.html?id=${id}&token=${token}` +
      `&resourceCenter=${resourceCenter}&resourceCenterApiPrefix=${resourceCenterApiPrefix}` +
      `&shenyue=${shenyue}&shenyueApiPrefix=${shenyueApiPrefix}`)
    }

    const handleShowEditSheetButton = () => {
      return window.location.href.search('/resource/sheet-songs/create/') === -1
    }

    return {
      formData,
      store,
      isHover,
      hasSheet,
      deleteVisible,
      handleMouseEnter,
      handleMouseLeave,
      handleBeforeUpload,
      handleDeleteSheet,
      showDeleteModal,
      handleDeleteCancel,
      jumpToEdit,
      handleShowEditSheetButton
    }
  }
}
</script>

<style lang="less">
.upload_card {
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
}

.upload_body {
  padding-top: 50px;
  width: 100%;
  height: 100%;
}

.upload_icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.icon {
  font-size: 40px;
  text-align: center;
}
.text {
  color: #999;
}
.main_body {
  min-height: 210px;
  .sheet-space{
    justify-content: space-between;
    .edit-sheet{
      padding: 0;
    }
  }
}
.sheet-space-work{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
